import { GQL } from "@binale-tech/shared";

import { withThinking } from "../runner/runAgent";
import type { AgentStep, ReportLine } from "../runner/types";
import { selectUnexported } from "./draftSelection";

export const draftsFromTransactionsStep: AgentStep = {
    id: "draftsFromTransactions",
    async run(ctx, io) {
        const kinds = [
            {
                kind: GQL.ITransactionExportKind.Bank,
                product: GQL.IProductKey.Bank,
                transactions: () => ctx.bankTransactions().map((tx) => ({ id: String(tx.id), date: tx.bookingDate })),
                thinkingId: "app.agent.txDrafts.bankThinking",
                doneId: "app.agent.txDrafts.bankDone",
                reportId: "app.agent.report.txDraftsBank",
            },
            {
                kind: GQL.ITransactionExportKind.Kasse,
                product: GQL.IProductKey.Kb,
                transactions: () => ctx.cashRegisterTransactions().map((tx) => ({ id: String(tx.id), date: tx.date })),
                thinkingId: "app.agent.txDrafts.kasseThinking",
                doneId: "app.agent.txDrafts.kasseDone",
                reportId: "app.agent.report.txDraftsKasse",
            },
        ] as const;

        const summary: ReportLine[] = [];
        let invalid = 0;
        let notFound = 0;
        for (const { kind, product, transactions, thinkingId, doneId, reportId } of kinds) {
            if (io.isCancelled()) break;
            const ids = selectUnexported(transactions(), ctx.exportedTransactionIds(kind), ctx.year);
            if (ids.length === 0) continue;
            if (!ctx.canWrite(product)) {
                io.narrateSkipped(product);
                continue;
            }
            const results = await withThinking(io, thinkingId, () => ctx.exportTransactions(kind, ids));
            const createdResults = results.filter((r) => r.outcome === GQL.ITransactionExportOutcome.Created);
            for (const r of createdResults) if (r.recordId) ctx.created.recordIds.push(r.recordId);
            invalid += results.filter((r) => r.outcome === GQL.ITransactionExportOutcome.Invalid).length;
            notFound += results.filter((r) => r.outcome === GQL.ITransactionExportOutcome.NotFound).length;
            if (createdResults.length > 0) {
                const values = { count: createdResults.length };
                io.post({ kind: "done", textId: doneId, values });
                summary.push({ textId: reportId, values });
            }
        }

        const open: ReportLine[] = [];
        if (invalid > 0) open.push({ textId: "app.agent.report.txDraftsInvalid", values: { count: invalid } });
        if (notFound > 0) open.push({ textId: "app.agent.report.txDraftsNotFound", values: { count: notFound } });
        return { status: summary.length > 0 || open.length > 0 ? "done" : "nothing", summary, open };
    },
};
